import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Utils } from '../../../shared/utils';
import { TracksService } from '../../../tracks/services/tracks.service';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as DrivingActions from '../actions/driving.actions';

@Injectable()
export class DrivingEffects {
  getRoute$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DrivingActions.getRoute.type),
      switchMap((action: any) => {
        return this.tracksService.getRoutes([action?.unitId], action?.dateFrom, action?.dateTo)
          .pipe(
            switchMap((routes) => {
              return of(DrivingActions.getRouteSuccess({route: routes[0]}));
            }),
            catchError(error => of(DrivingActions.getRouteFailure({error})))
          );
      })
    )
  );


  startRoute$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DrivingActions.startRoute.type),
      switchMap((action: any) => {
        return this.tracksService.startRoute(action?.unit, action.tripType)
          .pipe(
            switchMap((data) => {
              return of(DrivingActions.startRouteSuccess({data}));
            }),
            catchError(error => of(DrivingActions.startRouteFailure({error})))
          );
      })
    )
  );

  stopRoute$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DrivingActions.stopRoute.type),
      switchMap((action: any) => {
        return this.tracksService.stopRoute(action?.unitId)
          .pipe(
            switchMap((data) => {
              return of(DrivingActions.stopRouteSuccess({data}));
            }),
            catchError(error => of(DrivingActions.stopRouteFailure({error})))
          );
      })
    )
  );


  getDriving$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DrivingActions.getDriving.type),
      switchMap((action: any) => {
        return this.tracksService.getDriving()
          .pipe(
            switchMap((data) => {
              return of(DrivingActions.getDrivingSuccess({data}));
            }),
            catchError(error => of(DrivingActions.getDrivingFailure({error})))
          );
      })
    )
  );

  private utils: Utils;
  constructor(
    private actions$: Actions,
    private store$: Store<any>,
    private tracksService: TracksService,
  ) {
    this.utils = new Utils();
  }
}
